import {
    errorCannotCompleteRequestLineOne,
    errorCannotCompleteRequestLineTwo,
    safeToCloseString,
} from './EmptyStateReadingPane.locstring.json';
import { emptyStateMessageSelectAnItemToRead } from 'owa-locstrings/lib/strings/emptystatemessageselectanitemtoread.locstring.json';
import { contentPaneLabel } from 'owa-locstrings/lib/strings/contentpanelabel.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { isDeepLink } from 'owa-url';
import { getIsLightBaseTheme } from 'owa-theme';
import { observer } from 'mobx-react-lite';
import { updateAddinOnNavigationToEmptyNullReadingPane } from 'owa-mail-addins';

const classNames = require('classnames');
const styles = require('./EmptyStateReadingPane.scss');

export interface EmptyStateReadingPaneProps {
    isError?: boolean;
    emptyStateIcon?: string;
    emptyStateText?: string;
}

const EmptyStateReadingPane = observer(function EmptyStateReadingPane(
    props: EmptyStateReadingPaneProps
) {
    React.useEffect(() => {
        updateAddinOnNavigationToEmptyNullReadingPane();
    }, []);

    const isLightModeBaseTheme = getIsLightBaseTheme();
    const NO_SELECTION_SVG = isLightModeBaseTheme
        ? require('../svg/colored/noSelection.svg')
        : require('../svg/gray/noSelection.svg');
    let emptyStateIcon = NO_SELECTION_SVG;
    let mainMessageText = loc(emptyStateMessageSelectAnItemToRead);
    let detailsMessageText = null;

    const mainMessageClassNames = classNames(styles.messageText, styles.mainMessageText);
    const detailMessageClassNames = classNames(styles.messageText, styles.detailsMessageText);

    if (props.isError) {
        const EMPTY_ERROR_SVG = isLightModeBaseTheme
            ? require('../svg/colored/connectionError.svg')
            : require('../svg/gray/connectionError.svg');
        emptyStateIcon = EMPTY_ERROR_SVG;
        mainMessageText = loc(errorCannotCompleteRequestLineOne);
        detailsMessageText = loc(errorCannotCompleteRequestLineTwo);
    } else if (isDeepLink()) {
        mainMessageText = loc(safeToCloseString);
    } else {
        if (props.emptyStateIcon) {
            emptyStateIcon = props.emptyStateIcon;
        }

        if (props.emptyStateText) {
            mainMessageText = props.emptyStateText;
        }
    }

    return (
        <div
            key="emptyStateReadingPaneDiv"
            className={styles.emptyState}
            tabIndex={-1}
            role={'main'}
            aria-label={loc(contentPaneLabel)}>
            <img src={emptyStateIcon} aria-label={mainMessageText} width="120px" height="120px" />
            <div className={mainMessageClassNames}>{mainMessageText}</div>
            {detailsMessageText && (
                <div className={detailMessageClassNames}>{detailsMessageText}</div>
            )}
        </div>
    );
});
export default EmptyStateReadingPane;
